import './styles.scss'
import React from 'react'
import { Table } from 'antd'

const TableRecentTransaction = ({ columns, dataSource, ...props }) => (
  <Table className="recent-transaction-table" columns={columns} dataSource={dataSource} {...props} />
)

export default TableRecentTransaction
